// filepath: d:\Mes sites Web\animaux-de-la-seconde-chance\src\store\storeSideBar.js
import { ref } from 'vue';

export const isSidebarOpen = ref(false); // État de la sidebar (ouverte/fermée)
export const sidebarWidth = ref('0px'); // Largeur de la sidebar

export const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
  sidebarWidth.value = isSidebarOpen.value ? '16rem' : '0px';
};

export const closeSidebar = () => {
  isSidebarOpen.value = false;
  sidebarWidth.value = '0px';
};

export const openSidebar = () => {
  isSidebarOpen.value = true;
  sidebarWidth.value = '16rem';
};